(() => {
  if (window.lpSizeGuideReady) return;
  window.lpSizeGuideReady = true;

  const getCards = (guide) => Array.from(guide.querySelectorAll('[data-size-eu]'));
  const getButtons = (guide) => Array.from(guide.querySelectorAll('[data-us-size-mode]'));

  const setMode = (guide, mode) => {
    const track = guide.querySelector('[data-us-size-track]');

    getButtons(guide).forEach((button) => {
      const active = button.dataset.usSizeMode === mode;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    getCards(guide).forEach((card) => {
      const eu = parseFloat(card.dataset.sizeEu);
      const hidden = (mode === 'f' && eu > 43) || (mode === 'm' && eu < 39);
      card.hidden = hidden;
    });

    if (track) track.scrollLeft = 0;
  };

  const initGuide = (guide) => {
    if (!guide || guide.dataset.usSizeReady === 'true') return;
    guide.dataset.usSizeReady = 'true';
    setMode(guide, 'm');
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-us-size-guide]').forEach(initGuide);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-us-size-mode]');
    if (!button) return;

    const guide = button.closest('[data-us-size-guide]');
    if (!guide) return;

    setMode(guide, button.dataset.usSizeMode);
  });

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  initAll();
})();
